import * as React from 'react';
import { ActivityNavbar } from '../../../Shared';
import { DropdownObjectInterface } from '../../../Staff/interfaces/evidenceInterfaces';

interface StudentNavbarProps {
  isELLDiagnostic: boolean;
  language?: string;
  languageOptions?: DropdownObjectInterface[];
  translate?: (language: string) => string;
  updateLanguage?: (language: string) => void;
}

export const StudentNavbar: React.FC<StudentNavbarProps> = (props) => (
  <ActivityNavbar
    isELLDiagnostic={props.isELLDiagnostic}
    language={props.language}
    languageOptions={props.languageOptions}
    layoutVariant="student"
    showLanguagePicker={true}
    toolName="diagnostic"
    translate={props.translate}
    updateLanguage={props.updateLanguage}
    useShowTranslationsCheck={false}
  />
);

export default StudentNavbar;
